module.exports = __webpack_public_path__ + "img/40.16c5107a.webp";